import React from "react";
import Form from "react-bootstrap/Form";
import cs from "classnames";
import "./styles.scss";

const CustomInput = ({
  label,
  wrapperClasses = "",
  formControlClass = "",
  id,
  ...res
}: any) => {
  return (
    <div className={wrapperClasses}>
      <Form.Group
        className={cs("m-0 default-input", {
          [formControlClass]: formControlClass,
        })}
      >
        {label && <Form.Label>{label}</Form.Label>}
        <Form.Control {...res} />
      </Form.Group>
    </div>
  );
};
export default CustomInput;
